import React from 'react';

interface ProgressBarProps {
  current: number;
  total: number;
  path?: string[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ current, total, path = [] }) => {
  const percentage = (current / total) * 100;

  const getQuestionTitle = (questionId: string) => {
    const titles: { [key: string]: string } = {
      'Q1': 'Scope',
      'Q2A': 'Collaboration',
      'Q2B': 'Uncertainty',
      'Q2C': 'Dependencies',
      'Q3A': 'Item Count',
      'Q3B': 'Dependencies',
      'Q3C': 'One-way Door',
      'Q4': 'Beneficiary',
      'Q5': 'High Stakes',
      'Q6': 'Volume'
    };
    return titles[questionId] || questionId;
  };

  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-[var(--text-sec)]">
          Question {current} of {total}
        </span>
        <span className="text-sm text-[var(--text-sec)]">
          {Math.round(percentage)}% complete
        </span>
      </div>
      
      {/* Progress Bar */}
      <div className="w-full bg-[var(--hover-tint)] rounded-full h-2 mb-4">
        <div
          className="bg-[var(--slate)] h-2 rounded-full transition-all duration-300 ease-out"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Path Breadcrumb */}
      {path.length > 0 && (
        <div className="flex items-center space-x-2 text-xs text-[var(--text-ter)]">
          <span>Path:</span>
          {path.map((questionId, index) => (
            <React.Fragment key={questionId}>
              <span className="px-2 py-1 bg-[var(--hover-tint)] rounded">
                {getQuestionTitle(questionId)}
              </span>
              {index < path.length - 1 && (
                <span>→</span>
              )}
            </React.Fragment>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProgressBar;






